module.exports = __webpack_public_path__ + "account/assets/1.8cb5e12b.svg";